export class Utils {
  static instance: Utils;
  success: boolean;
  refreshParentOnClose: boolean;

  private constructor() {
    this.success = false;
    this.refreshParentOnClose = false;
  }

  setSuccess(value: boolean): void {
    this.success = value;
  }

  setRefreshParentOnClose(value: boolean): void {
    this.refreshParentOnClose = value;
  }

  /* withDelay: Workaround for https://jira.int.corefiling.com/browse/SEAHORSE-12510. */
  HideFancyModal(success: boolean, returnUrl?: string, withDelay?: boolean): void {
    const toRun = () => {
      Utils.getInstance().HideFancyModalInternal(success, returnUrl);
    };
    if (withDelay) {
      setTimeout(toRun, 1);
    } else {
      toRun();
    }
  }

  private HideFancyModalInternal(success: boolean, returnUrl?: string): void {
    //set sh.fancybox.success so that any $.fancybox.close event handlers can tell if the user clicked OK/Cancel
    this.setSuccess(success);

    if (parent && returnUrl && returnUrl != '') {
      this.redirectParentToUrl(returnUrl);
    }

    // hide modal
    if (parent) {
      parent.$.fancybox.close();
    }
  }

  private redirectParentToUrl(returnUrl: string): void {
    parent.window.location.href = unescape(returnUrl);
  }

  iFrameReloadResize(): void {
    this.resizeInternal($(document).find('div.fancyModalBox'));
  }

  resize(selector: string): void {
    this.resizeInternal($(selector));
  }

  resizeInternal(element: JQuery): void {
    const outerDiv = parent.$('#fancybox-wrap');
    const innerDiv = parent.$('#fancybox-content');
    const getValidHeightIfFancyModal = (currentHeight: number): number => {
      const progressContainer = $('#progress-container');
      const progressContainerHeight = progressContainer.height();
      // moving logic for handling fancyModal progress-container from modal.ts to here
      if (
        progressContainer.hasClass('fancyModalBox') &&
        progressContainer.is(':visible') &&
        progressContainerHeight !== undefined &&
        progressContainerHeight > currentHeight - 40
      ) {
        return progressContainerHeight + 40;
      }
      return currentHeight;
    };

    setTimeout(function () {
      if (element && element.length > 0) {
        const width = element.outerWidth()!;

        const height = getValidHeightIfFancyModal(element.outerHeight()!);
        outerDiv.stop(true).animate(
          {
            width: width,
            height: height,

            left: '-=' + (width - outerDiv.width()!) / 2,

            top: Math.max(outerDiv.position().top - (height - outerDiv.height()!) / 2, 0),
          },
          {
            duration: 200,
          },
        );

        innerDiv.stop(true).animate(
          {
            width: width,
            height: height,
          },
          {
            duration: 200,
          },
        );
      }
    }, 1);
  }

  refreshParentPage(): void {
    parent.$(parent.document.body).block({ message: '<span>' + UiText.t('Shared_Loading_Text') + '</span>' });
    parent.location.reload();
  }

  // tmm: Unlike the other fancybox methods, this injects the crazy wrappers. Because you're worth it.
  // Please extend this method rather than adding overloads. I hate method profiterolation.
  prepareFancyboxWithContent(toClick: JQuery, toShowId: string, width: number, height: number): void {
    $(toShowId).wrapInner('<div id="dialogHold" class="fancyModalBox"><div class="inner editHold"/></div>');
    toClick.prop('href', toShowId);
    this.createWithTypeCompleteAndCloseFunction(
      toClick,
      width,
      height,
      undefined,
      'inline',
      () => undefined,
      () => undefined,
    );
  }

  create(linkBtn: JQuery | JQueryStatic, width: number, height: number, urlString: string | undefined): void {
    this.createWithTypeAndCloseFunction(linkBtn, width, height, urlString, 'iframe', () => undefined);
  }

  createWithCloseFunction(
    linkBtn: JQuery | JQueryStatic,
    width: number,
    height: number,
    urlString: string | undefined,
    closeFunction: FancyBoxOptions['onClosed'],
  ): void {
    this.createWithTypeAndCloseFunction(linkBtn, width, height, urlString, 'iframe', closeFunction);
  }

  private createWithTypeAndCloseFunction(
    linkBtn: JQuery | JQueryStatic,
    width: number,
    height: number,
    urlString: string | undefined,
    type: FancyBoxOptions['type'],
    closeFunction: FancyBoxOptions['onClosed'],
  ): void {
    this.createWithTypeCompleteAndCloseFunction(linkBtn, width, height, urlString, type, () => undefined, closeFunction);
  }

  private createWithTypeCompleteAndCloseFunction(
    linkBtn: JQuery | JQueryStatic,
    width: number,
    height: number,
    urlString: string | undefined,
    type: FancyBoxOptions['type'],
    completeFunction: FancyBoxOptions['onComplete'],
    closeFunction: FancyBoxOptions['onClosed'],
  ): void {
    // [tmm] TODO push this further back.
    const builder = new FancyboxBuilder({
      width: width,
      height: height,
      type: type,
      onComplete: completeFunction,
      onClosed: closeFunction,
    });
    if (urlString !== undefined && urlString !== null) {
      builder.setRelativeHref(urlString);
    }
    builder.build(linkBtn);
  }

  static getInstance(): Utils {
    if (!Utils.instance) {
      Utils.instance = new Utils();
    }

    return Utils.instance;
  }
}

// Minimal spec example for <a> tag with href:
// { width: 100, height: 100, type: "iframe" }.
export class FancyboxBuilder {
  options: FancyBoxOptions = {
    type: 'iframe',
    padding: 0,
    transitionIn: 'none',
    transitionOut: 'none',
    autoDimensions: false,
    scrolling: 'no',
    modal: false,
    titleShow: false,
    hideOnContentClick: false,
    hideOnOverlayClick: false,
    enableEscapeButton: true,
  };

  constructor(options: FancyBoxOptions) {
    this.options = { ...this.options, ...options };
  }

  setRelativeHref(relativePath: string): FancyboxBuilder {
    this.options.href = window.rootDirectory + relativePath;
    return this;
  }

  build(element: JQuery | JQueryStatic): void {
    const startFunction = this.options.onStart;
    this.options.onStart = () => {
      // reset sh.fancybox.success
      //sh.fancybox.success = false;

      //reset refresh parent on close (used in error case).
      Utils.getInstance().setRefreshParentOnClose(false);

      setCloseButtonShowInternal($('#fancybox-close'), true);

      startFunction?.();
    };

    const closeFunction = this.options.onClosed;
    this.options.onClosed = () => {
      if (Utils.getInstance().refreshParentOnClose) {
        Utils.getInstance().refreshParentPage();
        return; // We should not reach this point as the page is refreshing but for some reason we do in Chrome.
      }

      if (closeFunction != null) {
        closeFunction(Utils.getInstance().success);
      }

      // reset sh.fancybox.success
      Utils.getInstance().setSuccess(false);
    };

    element.fancybox(this.options);
  }
}

export function setupProgress(oldStyle?: boolean): void {
  if (oldStyle) {
    $('body').append(
      $(
        '<div id="progress-container" class="fancyModalBox" style="display: none;"><p id="progressTitle" class="blueTitle"></p><div class="loading-container"><p id="progressMessage" style="margin-left: 25px;">' +
          UiText.t('Progress_ProcessingDocument_Text') +
          '</p></div></div>',
      ),
    );
  } else {
    $('body').append(
      $(
        '<div id="progress-container" class="dialogPadding" style="display: none;"><div class="panel panel-primary"><div class="panel-heading"><h1 id="progressTitle"></h1><div class="loading-container spinner"><p id="progressMessage" style="margin-left: 25px;">' +
          UiText.t('Progress_ProcessingDocument_Text') +
          '</p></div></div></div></div>',
      ),
    );
  }
}

export function setFancyIFrameCloseButtonShow(shouldShow: boolean): void {
  setCloseButtonShowInternal(parent.$('#fancybox-close'), shouldShow);
}

function setCloseButtonShowInternal(fancyBoxClose: JQuery, shouldShow: boolean): void {
  if (fancyBoxClose && fancyBoxClose.length > 0) {
    if (shouldShow) {
      fancyBoxClose.show();
    } else {
      fancyBoxClose.hide();
    }
  }
}
